import React, { useState, useEffect } from 'react';

import PropTypes from 'prop-types';
import Heading from '@tds/core-heading';
import Text from '@tds/core-text';

import ServiceForm from './serviceForm';
import ServiceList from './serviceList';

import { getPathVariables } from '../../misc';
import {
  getContentfulData,
  contentfulFormConfig,
  getData
} from '../../contentful';
import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';

const ServiceContactCentre = ({
  contactCentreServices,
  setContactCentreServices,
  setIsFormTouched
}) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    callCentre: { labelContactCentreServices }
  } = localizedStrings;

  const [servicesList, setServicesList] = useState([]);
  const [editService, setEditService] = useState();
  const locale = getPathVariables(window.location.pathname)[0];
  const config = {
    ...contentfulFormConfig,
    content_type: 'contactCentreServices',
    locale
  };

  useEffect(() => {
    getContentfulData(config).then(res => {
      const list = getData(res).serviceList.map(service => {
        return service.fields;
      });
      setServicesList(list);
    });
  }, []);

  return (
    <>
      <div style={{ margin: '1rem 0' }}>
        <Heading level="h2" tag="h3">
          {labelContactCentreServices}
        </Heading>
      </div>
      <div style={{ margin: '1rem 0', color: '#c12335' }}>
        <Text bold>Note: </Text>Business Connect order has to be entered{' '}
        <span style={{ fontStyle: 'italic' }}>additionally</span> in the TELUS
        Business Services Tool to be processed. This form will not trigger the
        Business Connect order and is for contract generation purposes only. For
        questions please reach out to Faisal Khurshid at{' '}
        <a href="mailto:faisal.khurshid@telus.com">Faisal.Khurshid@telus.com</a>
      </div>
      <div style={{ margin: '1rem 0', color: '#c12335' }}>
        <Text bold>Note: </Text>Contact Centre seats and Business Connect Seats
        have to be in a 1*1 ratio
      </div>

      <ServiceForm
        contactCentreServices={contactCentreServices}
        setContactCentreServices={setContactCentreServices}
        servicesList={servicesList}
        editService={editService}
        setEditService={setEditService}
        setIsFormTouched={setIsFormTouched}
      />
      {((!editService && contactCentreServices.length > 0) ||
        (editService && contactCentreServices.length > 1)) && (
        <ServiceList
          contactCentreServices={contactCentreServices}
          setContactCentreServices={setContactCentreServices}
          setEditService={setEditService}
          setIsFormTouched={setIsFormTouched}
          editService={editService}
        />
      )}
    </>
  );
};

ServiceContactCentre.propTypes = {
  contactCentreServices: PropTypes.arrayOf(PropTypes.any).isRequired,
  setContactCentreServices: PropTypes.func.isRequired,
  setIsFormTouched: PropTypes.func.isRequired
};

export default ServiceContactCentre;
